import {
    RaikoBaseDialogContentContainer,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {ProductService} from "../../../serverService/productService/ProductService";

export default function AddNewProduct({handleCloseProductDialog,handleAddNewProduct}) {

    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false);
    const service = new ProductService()

    function handleCreateNewProduct() {
        setButtonLoading(true)
        service.addNewProduct(title,slug)
            .then(response=>{
                handleCloseProductDialog()
                handleAddNewProduct(response)
                showSuccessMessage("محصول جدید با موفقیت افزوده شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            setButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن محصول جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonOnclickWithValidation={handleCreateNewProduct}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseProductDialog}
                actionButtonLoadingState={buttonLoading}
            >
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"slug"}
                    value={slug}
                    setValue={setSlug}
                    required
                />

            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}